module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_0.ba0a5077.png";